module.exports = __webpack_public_path__ + "vrgroup.3f56b94588599394b90b.worker.js"